import { CostReportSearchCommand } from '../../../proxies/cost-reports.proxy.service';
import { CostSourceFilter } from '../models/cost-analysis.models';
import { CostAnalysisFilters } from '../services/cost-analysis-state.service';

export function hasActiveFilters(f: CostAnalysisFilters): boolean {
  return (
    f.fabricCodes.length > 0 ||
    f.colorReferences.length > 0 ||
    f.productionCardNumbers.length > 0 ||
    f.workOrderReferences.length > 0 ||
    f.rollNumbers.length > 0 ||
    f.customerReferences.length > 0 ||
    f.orderTypes.length > 0 ||
    f.onlyCompletedRolls
  );
}

export function toSearchCommand(src: CostSourceFilter, f: CostAnalysisFilters): CostReportSearchCommand {
  return {
    costSource: src,
    fabricCodes: f.fabricCodes.length ? f.fabricCodes : null,
    colorReferences: f.colorReferences.length ? f.colorReferences : null,
    productionCardNumbers: f.productionCardNumbers.length ? f.productionCardNumbers : null,
    workOrderReferences: f.workOrderReferences.length ? f.workOrderReferences : null,
    rollNumbers: f.rollNumbers.length ? f.rollNumbers : null,
    customerReferences: f.customerReferences.length ? f.customerReferences : null,
    orderTypes: f.orderTypes.length ? f.orderTypes : null,
  };
}

export function buildSearchCommand(src: CostSourceFilter, f: CostAnalysisFilters): CostReportSearchCommand | null {
  if (!hasActiveFilters(f)) return null;
  return toSearchCommand(src, f);
}
